<div class="card container">
  <div class="row justify-content-start" style="padding-top: 1rem">
    <div class="col-auto align-self-end">
      <h3 class="card-title" style="margin-bottom: 0">{{ titulo }}</h3>
    </div>
    <div class="col-auto align-self-start">
      <p-button
        label="Exportar"
        severity="primary"
        icon="pi pi-file"
        size="small"
        (onClick)="exportToExcel()"
      />
    </div>
  </div>
  <div style="padding-top: 50px">
    <p-table
      #dt1
      [value]="ltsUsers"
      [tableStyle]="{
        'min-width': '50rem',
        'margin-bottom': '50px'
      }"
      styleClass="p-datatable-striped p-datatable-sm"
      [paginator]="true"
      [rows]="5"
      [rowsPerPageOptions]="[5, 10, 20]"
      [globalFilterFields]="['dri_name', 'dri_last_name', 'dri_phone']"
    >
      <ng-template pTemplate="caption">
        <div class="d-flex">
          <div class="col-4 align-items-left justify-content-center">
            <label for="buttondisplay" class="font-bold block px-2">
              Fecha Inicio
            </label>
            <p-calendar
              [(ngModel)]="dateStart"
              [showIcon]="true"
              inputId="buttondisplay"
              [showOnFocus]="false"
              dateFormat="dd-mm-yy"
              (onSelect)="getListUsers()"
            />
          </div>
          <div class="col-4 align-items-left justify-content-center">
            <label for="buttondisplay" class="font-bold block px-2">
              Fecha Fin
            </label>
            <p-calendar
              [(ngModel)]="dateEnd"
              [showIcon]="true"
              inputId="buttondisplay"
              [showOnFocus]="false"
              (onSelect)="getListUsers()"
              dateFormat="dd-mm-yy"
              class="m-3"
            />
          </div>
          <div class="col-4 align-items-left justify-content-center">
            <label for="buttondisplay" class="font-bold block px-2">
              Ciudades
            </label>
            <br>
              <p-dropdown
                [options]="ltsStates"
                [(ngModel)]="selectedState"
                optionLabel="pd_name"
                optionValue="pd_code"
                placeholder="Selecciona un estado"
                class="m-3"
                (onChange)="onStateChange()"
              />
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th id="name">Nombre y Apellido</th>
          <th id="phone">Telefono</th>
          <th id="email">Email</th>
          <th id="dateregister">Fecha de registro</th>
          <th id="city">Ciudad</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-user>
        <tr>
          <td>{{ user.usr_name }} {{ user.usr_last_name }}</td>
          <td>{{ user.usr_phone }}</td>
          <td>{{ user.usr_email }}</td>
          <td>{{ user.crea_date | date : "dd-MM-yyyy" }}</td>
          <td>{{ user.pd_name ? user.pd_name : "Sin información" }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
